[
  {
    "id": "b308-maschine",
    "paragraph": "3.08",
    "cite": [
      "1",
      "1a",
      "1b",
      "1c"
    ],
    "title": {
      "de": "Fahrzeug mit Maschinenantrieb, einzeln fahrend",
      "en": "Power-driven vessel proceeding alone (inland, Germany)"
    },
    "vessel": "coaster",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd"
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [],
    "erklaerung": "Ein Topplicht, nicht zwei: das ist der auffälligste Unterschied zur See. Die Ordnung verlangt für das einzeln fahrende Fahrzeug mit Maschinenantrieb ein Topplicht auf dem vorderen Teil, die Seitenlichter und ein Hecklicht. Die Seitenlichter stehen mindestens einen Meter hinter dem Topplicht und sind binnenbords abgeblendet, damit das grüne Licht nicht von Backbord und das rote nicht von Steuerbord zu sehen ist.",
    "tags": [
      "maschine",
      "in-fahrt",
      "topplicht"
    ]
  },
  {
    "id": "b308-lang",
    "paragraph": "3.08",
    "cite": [
      "1",
      "1a",
      "1b",
      "1c",
      "2"
    ],
    "title": {
      "de": "Fahrzeug mit Maschinenantrieb über 110 m",
      "en": "Power-driven vessel over 110 m (inland, Germany)"
    },
    "vessel": "grossmotorschiff",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-aft",
        "tier": 1
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [],
    "erklaerung": "Über 110,00 m Länge kommt ein zweites Topplicht dazu, und zwar auf dem Achterschiff und höher als das vordere. Damit sieht das Bild aus wie auf See, es entsteht aber aus einer anderen Grenze: auf See trennt Regel 23 bei 50 m, auf dem Binnenwasser die Ordnung bei 110 m.",
    "tags": [
      "maschine",
      "in-fahrt",
      "topplicht",
      "laenge"
    ]
  },
  {
    "id": "b309-schlepper",
    "paragraph": "3.09",
    "cite": [
      "1",
      "1a",
      "1b",
      "3.08:1a",
      "3.08:1b"
    ],
    "title": {
      "de": "Schleppverband, Fahrzeug an der Spitze",
      "en": "Towing vessel at the head of a tow (inland, Germany)"
    },
    "vessel": "tug",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 1
      },
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "yellow",
        "mount": "stern"
      }
    ],
    "dayShapes": [
      {
        "kind": "cylinder",
        "mount": "mast-fwd",
        "colour": "yellow"
      }
    ],
    "erklaerung": "Das Fahrzeug an der Spitze führt zusätzlich zum Topplicht und den Seitenlichtern ein zweites Topplicht, etwa einen Meter unter dem ersten. Hinten brennt statt des weißen ein gelbes Hecklicht, damit der Anhang weiß, wem er folgt. Bei Tag steht auf dem Vorschiff ein gelber Zylinder mit schwarzen und weißen Streifen.",
    "tags": [
      "schleppverband",
      "in-fahrt",
      "topplicht",
      "gelb"
    ]
  },
  {
    "id": "b309-schlepper-nebeneinander",
    "paragraph": "3.09",
    "cite": [
      "1",
      "1a",
      "2",
      "2a",
      "2b",
      "3.08:1a",
      "3.08:1b"
    ],
    "title": {
      "de": "Schleppverband, zwei Fahrzeuge nebeneinander an der Spitze",
      "en": "Two towing vessels abreast at the head (inland, Germany)"
    },
    "vessel": "tug",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 2
      },
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 1
      },
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "yellow",
        "mount": "stern"
      }
    ],
    "dayShapes": [
      {
        "kind": "cylinder",
        "mount": "mast-fwd",
        "colour": "yellow"
      }
    ],
    "erklaerung": "Ziehen mehrere Fahrzeuge mit Maschinenantrieb nebeneinander, führt jedes von ihnen ein drittes Topplicht, etwa zwei Meter unter dem ersten. Drei Topplichter senkrecht übereinander heißen auf dem Binnenwasser also nicht Schubverband, sondern Schleppverband mit mehreren Fahrzeugen an der Spitze.",
    "tags": [
      "schleppverband",
      "in-fahrt",
      "topplicht"
    ]
  },
  {
    "id": "b309-geschleppt",
    "paragraph": "3.09",
    "cite": [
      "3",
      "3a",
      "3b"
    ],
    "title": {
      "de": "Geschlepptes Fahrzeug im Schleppverband",
      "en": "Towed vessel in a tow (inland, Germany)"
    },
    "vessel": "barge",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "allround",
        "colour": "white",
        "mount": "best-seen"
      }
    ],
    "dayShapes": [
      {
        "kind": "ball",
        "mount": "best-seen",
        "colour": "yellow"
      }
    ],
    "erklaerung": "Der Anhang führt ein einziges weißes helles Licht, von allen Seiten sichtbar, und bei Tag einen gelben Ball. Überschreitet eine Anhanglänge 110,00 m, sind es nachts zwei solche Lichter, eines auf der vorderen und eines auf der hinteren Hälfte.",
    "tags": [
      "schleppverband",
      "in-fahrt",
      "rundumlicht"
    ]
  },
  {
    "id": "b310-schubverband",
    "paragraph": "3.10",
    "cite": [
      "1",
      "1a",
      "1b",
      "1c"
    ],
    "title": {
      "de": "Schubverband in Fahrt",
      "en": "Pushed convoy underway (inland, Germany)"
    },
    "vessel": "schubverband",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 2
      },
      {
        "type": "masthead",
        "colour": "white",
        "mount": "yardarm-port",
        "tier": 0
      },
      {
        "type": "masthead",
        "colour": "white",
        "mount": "yardarm-stbd",
        "tier": 0
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern",
        "versatzM": -1.25
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern",
        "versatzM": 1.25
      }
    ],
    "dayShapes": [],
    "erklaerung": "Drei Topplichter als gleichseitiges Dreieck mit waagerechter Grundlinie: das ist das Zeichen des Schubverbandes. Die beiden unteren stehen 1,25 m voneinander und 1,10 m unter dem obersten. Die Seitenlichter sitzen so weit hinten wie möglich am breitesten Teil des Verbandes, nicht am schiebenden Fahrzeug. Achtern brennen drei Hecklichter nebeneinander.",
    "tags": [
      "schubverband",
      "in-fahrt",
      "topplicht"
    ]
  },
  {
    "id": "b310-geschleppt",
    "paragraph": "3.10",
    "cite": [
      "1",
      "1a",
      "1b",
      "1c",
      "3"
    ],
    "title": {
      "de": "Geschleppter Schubverband",
      "en": "Pushed convoy under tow (inland, Germany)"
    },
    "vessel": "schubverband",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 2
      },
      {
        "type": "masthead",
        "colour": "white",
        "mount": "yardarm-port",
        "tier": 0
      },
      {
        "type": "masthead",
        "colour": "white",
        "mount": "yardarm-stbd",
        "tier": 0
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "yellow",
        "mount": "stern",
        "tier": 0
      }
    ],
    "dayShapes": [],
    "erklaerung": "Wird ein Schubverband geschleppt, bleibt vorn alles gleich, achtern werden die drei Hecklichter gelb. Die Farbe des Hecklichts sagt also, ob der Verband geschoben oder gezogen wird.",
    "tags": [
      "schubverband",
      "schleppverband",
      "in-fahrt",
      "gelb"
    ]
  },
  {
    "id": "b311-gekuppelt",
    "paragraph": "3.11",
    "cite": [
      "1",
      "1a",
      "1b",
      "1c"
    ],
    "title": {
      "de": "Gekuppelte Fahrzeuge in Fahrt",
      "en": "Vessels coupled side by side (inland, Germany)"
    },
    "vessel": "motor-vessel-30",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd"
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [],
    "erklaerung": "Jedes gekuppelte Fahrzeug führt sein eigenes Topplicht nach § 3.08. Von vorn stehen deshalb zwei Topplichter nebeneinander, nicht übereinander: daran erkennt man den Verband gekuppelter Fahrzeuge und unterscheidet ihn vom Schubverband mit seinem Dreieck.",
    "tags": [
      "gekuppelt",
      "in-fahrt",
      "topplicht"
    ]
  },
  {
    "id": "b312-segel",
    "paragraph": "3.12",
    "cite": [
      "1",
      "1a",
      "1b"
    ],
    "title": {
      "de": "Fahrzeug unter Segel in Fahrt",
      "en": "Sailing vessel underway (inland, Germany)"
    },
    "vessel": "sailing-yacht",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [],
    "erklaerung": "Seitenlichter und Hecklicht, sonst nichts. Die Ordnung kennt für das Fahrzeug unter Segel weder die Dreifarbenlaterne im Topp noch die beiden Rundumlichter rot über grün, die die Seeregeln erlauben. Wer auf dem Binnenwasser ein Fahrzeug ohne Topplicht sieht, sieht ein Segelfahrzeug.",
    "tags": [
      "segel",
      "in-fahrt",
      "seitenlichter"
    ]
  },
  {
    "id": "b313-kleinfahrzeug-maschine",
    "paragraph": "3.13",
    "cite": [
      "1",
      "1a",
      "1b",
      "1c"
    ],
    "title": {
      "de": "Kleinfahrzeug mit Maschinenantrieb",
      "en": "Small craft under power (inland, Germany)"
    },
    "vessel": "motorboat",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "bow"
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [],
    "erklaerung": "Dasselbe Bild wie beim großen Fahrzeug, nur schwächer: das Topplicht ist hell statt stark, die Seitenlichter dürfen gewöhnliche Lichter sein. Es steht in gleicher Höhe wie die Seitenlichter und mindestens einen Meter vor ihnen.",
    "tags": [
      "kleinfahrzeug",
      "maschine",
      "in-fahrt"
    ]
  },
  {
    "id": "b314-blau-1",
    "paragraph": "3.14",
    "cite": [
      "1",
      "1a",
      "1b",
      "3.02:1",
      "3.08:1a",
      "3.08:1b",
      "3.08:1c"
    ],
    "title": {
      "de": "Entzündbare Stoffe: ein blaues Licht",
      "en": "Flammable cargo: one blue light (inland, Germany)"
    },
    "vessel": "motor-vessel-30",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd"
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      },
      {
        "type": "allround",
        "colour": "blue",
        "mount": "best-seen",
        "tier": 0
      }
    ],
    "dayShapes": [
      {
        "kind": "cone-down",
        "mount": "best-seen",
        "colour": "blue",
        "tier": 0
      }
    ],
    "erklaerung": "Ein blaues Licht bei Nacht, ein blauer Kegel mit der Spitze nach unten bei Tag: das Fahrzeug befördert bestimmte entzündbare Stoffe nach Tabelle A des ADN. Die Bezeichnung kommt zu der hinzu, die das Fahrzeug ohnehin führt.",
    "tags": [
      "gefahrgut",
      "in-fahrt",
      "blau"
    ]
  },
  {
    "id": "b314-blau-2",
    "paragraph": "3.14",
    "cite": [
      "2",
      "2a",
      "2b",
      "3.02:1",
      "3.08:1a",
      "3.08:1b",
      "3.08:1c"
    ],
    "title": {
      "de": "Gesundheitsschädliche Stoffe: zwei blaue Lichter",
      "en": "Harmful cargo: two blue lights (inland, Germany)"
    },
    "vessel": "motor-vessel-30",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd"
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      },
      {
        "type": "allround",
        "colour": "blue",
        "mount": "best-seen",
        "tier": 0
      },
      {
        "type": "allround",
        "colour": "blue",
        "mount": "best-seen",
        "tier": 1
      }
    ],
    "dayShapes": [
      {
        "kind": "cone-down",
        "mount": "best-seen",
        "colour": "blue",
        "tier": 0
      },
      {
        "kind": "cone-down",
        "mount": "best-seen",
        "colour": "blue",
        "tier": 1
      }
    ],
    "erklaerung": "Zwei blaue Lichter oder zwei blaue Kegel stehen für bestimmte gesundheitsschädliche Stoffe. Die Zahl der blauen Zeichen ist die Stufe: eins, zwei oder drei, und drei ist die schärfste.",
    "tags": [
      "gefahrgut",
      "in-fahrt",
      "blau"
    ]
  },
  {
    "id": "b314-blau-3",
    "paragraph": "3.14",
    "cite": [
      "3",
      "3a",
      "3b",
      "3.02:1",
      "3.08:1a",
      "3.08:1b",
      "3.08:1c"
    ],
    "title": {
      "de": "Explosive Stoffe: drei blaue Lichter",
      "en": "Explosive cargo: three blue lights (inland, Germany)"
    },
    "vessel": "motor-vessel-30",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd"
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      },
      {
        "type": "allround",
        "colour": "blue",
        "mount": "best-seen",
        "tier": 0
      },
      {
        "type": "allround",
        "colour": "blue",
        "mount": "best-seen",
        "tier": 1
      },
      {
        "type": "allround",
        "colour": "blue",
        "mount": "best-seen",
        "tier": 2
      }
    ],
    "dayShapes": [
      {
        "kind": "cone-down",
        "mount": "best-seen",
        "colour": "blue",
        "tier": 0
      },
      {
        "kind": "cone-down",
        "mount": "best-seen",
        "colour": "blue",
        "tier": 1
      },
      {
        "kind": "cone-down",
        "mount": "best-seen",
        "colour": "blue",
        "tier": 2
      }
    ],
    "erklaerung": "Drei blaue Lichter übereinander oder drei blaue Kegel: das Fahrzeug befördert bestimmte explosive Stoffe. Abstand halten ist hier keine Höflichkeit, sondern Vorschrift.",
    "tags": [
      "gefahrgut",
      "in-fahrt",
      "blau"
    ]
  },
  {
    "id": "b316-faehre",
    "paragraph": "3.16",
    "cite": [
      "1",
      "1a",
      "1b"
    ],
    "title": {
      "de": "Nicht frei fahrende Fähre",
      "en": "Cable ferry underway (inland, Germany)"
    },
    "vessel": "faehre",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "allround",
        "colour": "white",
        "mount": "best-seen",
        "tier": 0
      },
      {
        "type": "allround",
        "colour": "green",
        "mount": "best-seen",
        "tier": 1
      }
    ],
    "dayShapes": [],
    "erklaerung": "Grün über Weiß, beide von allen Seiten sichtbar: eine nicht frei fahrende Fähre, also eine Fähre am Seil oder an der Gierleine. Das grüne Licht steht etwa einen Meter über dem weißen. Wer dieses Paar sieht, hat ein Fahrzeug vor sich, das die Fahrrinne quert und dem Seil folgen muss.",
    "tags": [
      "faehre",
      "in-fahrt",
      "rundumlicht"
    ]
  },
  {
    "id": "b317-vorrang",
    "paragraph": "3.17",
    "cite": [
      "1",
      "3.08:1a",
      "3.08:1b",
      "3.08:1c"
    ],
    "title": {
      "de": "Fahrzeug mit Vorrang bei der Durchfahrt",
      "en": "Vessel granted priority passage (inland, Germany)"
    },
    "vessel": "motor-vessel-30",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd"
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [
      {
        "kind": "flag-a",
        "mount": "bow",
        "colour": "red"
      }
    ],
    "erklaerung": "Ein roter Wimpel auf dem Vorschiff sagt, dass die zuständige Behörde diesem Fahrzeug für eine Stelle mit fester Reihenfolge, etwa eine Schleuse oder eine Engstelle, den Vorrang eingeräumt hat. Nachts gibt es dafür kein eigenes Zeichen: der Wimpel ist eine Tagbezeichnung.",
    "tags": [
      "vorrang",
      "in-fahrt",
      "tagzeichen"
    ]
  },
  {
    "id": "b318-manoevrierunfaehig",
    "paragraph": "3.18",
    "cite": [
      "1",
      "1a",
      "1b",
      "3.08:1b",
      "3.08:1c"
    ],
    "title": {
      "de": "Manövrierunfähiges Fahrzeug",
      "en": "Vessel not under command (inland, Germany)"
    },
    "vessel": "motor-vessel-30",
    "underway": true,
    "makingWay": false,
    "lights": [
      {
        "type": "handlamp",
        "colour": "red",
        "mount": "best-seen"
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [
      {
        "kind": "flag-a",
        "mount": "best-seen",
        "colour": "red"
      }
    ],
    "erklaerung": "Kein festes Lichtbild, sondern eine Bewegung: ein rotes Licht, das im unteren Halbkreis geschwenkt wird, bei Tag eine rote Flagge oder Tafel, ebenso geschwenkt. Statt des Zeichens darf auch das vorgeschriebene Schallzeichen gegeben werden, oder beides zugleich. Auf See stehen dafür zwei rote Rundumlichter übereinander; auf dem Binnenwasser wird geschwenkt.",
    "tags": [
      "manoevrierunfaehig",
      "in-fahrt",
      "rot"
    ]
  },
  {
    "id": "b320-stillliegend",
    "paragraph": "3.20",
    "cite": [
      "1"
    ],
    "title": {
      "de": "Stillliegendes Fahrzeug",
      "en": "Vessel berthed or at anchor (inland, Germany)"
    },
    "vessel": "coaster",
    "underway": false,
    "makingWay": false,
    "lights": [
      {
        "type": "allround",
        "colour": "white",
        "mount": "best-seen"
      }
    ],
    "dayShapes": [],
    "erklaerung": "Ein weißes gewöhnliches Licht, von allen Seiten sichtbar, mindestens drei Meter über der Ebene der Einsenkungsmarken, und zwar auf der Fahrwasserseite. Erlaubt sind auch zwei solche Lichter in gleicher Höhe auf Vor- und Achterschiff. Die Fahrwasserseite ist der Unterschied zum Ankerlicht der See: beleuchtet wird die Seite, an der jemand vorbeikommt.",
    "tags": [
      "stillliegend",
      "rundumlicht"
    ]
  },
  {
    "id": "b320-kleinfahrzeug-stillliegend",
    "paragraph": "3.20",
    "cite": [
      "2"
    ],
    "title": {
      "de": "Stillliegendes Kleinfahrzeug",
      "en": "Small craft berthed (inland, Germany)"
    },
    "vessel": "motorboat",
    "underway": false,
    "makingWay": false,
    "lights": [
      {
        "type": "allround",
        "colour": "white",
        "mount": "best-seen"
      }
    ],
    "dayShapes": [],
    "erklaerung": "Auch das Kleinfahrzeug zeigt beim Stillliegen ein weißes gewöhnliches Licht auf der Fahrwasserseite. Ausgenommen ist nur das Beiboot.",
    "tags": [
      "stillliegend",
      "kleinfahrzeug",
      "rundumlicht"
    ]
  },
  {
    "id": "b321-gefahrgut-stillliegend",
    "paragraph": "3.21",
    "cite": [
      "1",
      "3.02:1",
      "3.14:1a",
      "3.14:1b",
      "3.20:1"
    ],
    "title": {
      "de": "Stillliegendes Fahrzeug mit gefährlichen Gütern",
      "en": "Berthed vessel carrying dangerous goods (inland, Germany)"
    },
    "vessel": "motor-vessel-30",
    "underway": false,
    "makingWay": false,
    "lights": [
      {
        "type": "allround",
        "colour": "white",
        "mount": "best-seen",
        "tier": 0
      },
      {
        "type": "allround",
        "colour": "blue",
        "mount": "best-seen",
        "tier": 1
      }
    ],
    "dayShapes": [
      {
        "kind": "cone-down",
        "mount": "best-seen",
        "colour": "blue",
        "tier": 1
      }
    ],
    "erklaerung": "Die blaue Bezeichnung nach § 3.14 gilt auch beim Stillliegen. Zum weißen Licht der Fahrwasserseite kommt also das blaue Licht der Ladung, bei Tag der blaue Kegel.",
    "tags": [
      "stillliegend",
      "gefahrgut",
      "blau"
    ]
  },
  {
    "id": "b325-schwimmendes-geraet",
    "paragraph": "3.25",
    "cite": [
      "1",
      "1a",
      "1b",
      "3.02:1"
    ],
    "title": {
      "de": "Schwimmendes Gerät bei der Arbeit",
      "en": "Floating plant at work (inland, Germany)"
    },
    "vessel": "workboat",
    "underway": false,
    "makingWay": false,
    "lights": [
      {
        "type": "allround",
        "colour": "green",
        "mount": "yardarm-stbd",
        "tier": 0
      },
      {
        "type": "allround",
        "colour": "green",
        "mount": "yardarm-stbd",
        "tier": 1
      },
      {
        "type": "allround",
        "colour": "red",
        "mount": "yardarm-port",
        "tier": 0
      }
    ],
    "dayShapes": [],
    "erklaerung": "Hier zeigen die Lichter nicht den Fahrzeugtyp, sondern den Weg: nach der Seite, an der die Durchfahrt frei ist, zwei grüne Lichter übereinander, nach der Seite, an der sie nicht frei ist, ein rotes. Das Gerät liegt beim Arbeiten still, und wer vorbeifährt, liest an der Farbe, auf welcher Seite er das tun darf.",
    "tags": [
      "arbeit",
      "stillliegend",
      "gruen",
      "rot"
    ]
  },
  {
    "id": "b327-behoerde",
    "paragraph": "3.27",
    "cite": [
      "1",
      "3.02:1",
      "3.08:1a",
      "3.08:1b",
      "3.08:1c"
    ],
    "title": {
      "de": "Fahrzeug der Überwachungsbehörden",
      "en": "Authority vessel showing a blue flashing light (inland, Germany)"
    },
    "vessel": "pilot-vessel",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd"
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      },
      {
        "type": "allround",
        "colour": "blue",
        "mount": "best-seen",
        "rhythm": "flashing"
      }
    ],
    "dayShapes": [],
    "erklaerung": "Ein blaues Funkellicht, bei Nacht wie bei Tag: ein Fahrzeug der Überwachungsbehörden macht sich kenntlich. Dasselbe Licht führen Feuerwehr, Wasserrettung im Einsatz und der Zivil- und Katastrophenschutz. Es ist das einzige blaue Licht der Ordnung, das blinkt; die blauen Lichter der Gefahrgutbezeichnung brennen gleichmäßig.",
    "tags": [
      "behoerde",
      "in-fahrt",
      "blau",
      "funkellicht"
    ]
  },
  {
    "id": "b328-arbeiten",
    "paragraph": "3.28",
    "cite": [
      "1",
      "3.08:1a",
      "3.08:1b",
      "3.08:1c"
    ],
    "title": {
      "de": "Fahrzeug bei Arbeiten in der Wasserstraße",
      "en": "Vessel working in the waterway (inland, Germany)"
    },
    "vessel": "workboat",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd"
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      },
      {
        "type": "allround",
        "colour": "yellow",
        "mount": "best-seen",
        "rhythm": "flashing"
      }
    ],
    "dayShapes": [],
    "erklaerung": "Ein gelbes Funkellicht, von allen Seiten sichtbar, bei Nacht wie bei Tag: das Fahrzeug führt mit Erlaubnis der Behörde Arbeiten, Peilungen oder Messungen in der Wasserstraße aus. Gelb warnt, Blau kennzeichnet die Behörde; die beiden Funkellichter sind nicht dasselbe.",
    "tags": [
      "arbeit",
      "in-fahrt",
      "gelb",
      "funkellicht"
    ]
  },
  {
    "id": "b326-anker-gefahr",
    "paragraph": "3.26",
    "cite": [
      "1",
      "3.20:1"
    ],
    "title": {
      "de": "Stillliegendes Fahrzeug, dessen Anker die Schifffahrt gefährdet",
      "en": "Moored vessel whose anchor endangers traffic (inland, Germany)"
    },
    "vessel": "coaster",
    "underway": false,
    "makingWay": false,
    "lights": [
      {
        "type": "allround",
        "colour": "white",
        "mount": "best-seen",
        "tier": 1
      },
      {
        "type": "allround",
        "colour": "white",
        "mount": "best-seen",
        "tier": 0
      }
    ],
    "dayShapes": [],
    "erklaerung": "Zwei weiße Lichter übereinander auf der Fahrwasserseite, das untere einen Meter unter dem oberen: das obere ist das gewöhnliche Stillliegelicht, das untere sagt, dass ein Anker, ein Ankerkabel oder eine Ankerkette in das Fahrwasser ragt. Wer das sieht, hält Abstand, denn die Gefahr liegt unter Wasser und nicht am Schiff.",
    "tags": [
      "stillliegend",
      "anker",
      "rundumlicht"
    ]
  },
  {
    "id": "b328a-bundeswehr",
    "paragraph": "3.28a",
    "cite": [
      "1",
      "3.08:1",
      "3.08:1a",
      "3.08:1b",
      "3.08:1c"
    ],
    "title": {
      "de": "Mehrzweckfahrzeug der Bundeswehr in Fahrt",
      "en": "Multi-purpose vessel of the German armed forces underway (inland, Germany)"
    },
    "vessel": "motorboat",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd"
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      },
      {
        "type": "allround",
        "colour": "yellow",
        "mount": "masthead-top",
        "tier": 2,
        "rhythm": "flashing"
      }
    ],
    "dayShapes": [],
    "erklaerung": "Das Lichterbild eines einzeln fahrenden Fahrzeugs mit Maschinenantrieb, darüber ein gelbes Funkellicht einen Meter über dem Topplicht. Es brennt bei Nacht und bei Tag. Das Fahrzeug verhält sich in der Fahrt wie ein Kleinfahrzeug, und genau darauf weist das Funkellicht hin: wer es sieht, hat kein gewöhnliches Fahrzeug dieser Größe vor sich.",
    "tags": [
      "in-fahrt",
      "funkellicht",
      "behoerde"
    ]
  },
  {
    "id": "b324-fischerei-netze",
    "paragraph": "3.24",
    "cite": [
      "1",
      "2a",
      "3.20:1"
    ],
    "title": {
      "de": "Stillliegendes Fischereifahrzeug mit ausgelegten Netzen",
      "en": "Moored fishing vessel with nets out (inland, Germany)"
    },
    "vessel": "trawler",
    "underway": false,
    "makingWay": false,
    "lights": [
      {
        "type": "allround",
        "colour": "white",
        "mount": "best-seen",
        "tier": 0
      }
    ],
    "dayShapes": [],
    "erklaerung": "Ein Fischereifahrzeug, das seine Netze oder Ausleger im Fahrwasser oder in dessen Nähe ausgelegt hat, führt beim Stillliegen das gewöhnliche weiße Licht auf der Fahrwasserseite. Die Netze selbst werden gesondert bezeichnet: bei Nacht durch weiße gewöhnliche Lichter in ausreichender Zahl, bei Tag durch gelbe Döpper oder gelbe Flaggen. Wer das Licht sieht, rechnet mit Netzen im Wasser und nicht nur mit einem liegenden Fahrzeug.",
    "tags": [
      "fischerei",
      "stillliegend",
      "rundumlicht"
    ]
  }
]
